import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  format(event) {
    // Get the current value
    let value = event.target.value
    
    // Convert to lowercase and replace invalid characters
    value = value.toLowerCase()
      .replace(/[^a-z0-9\-]/g, '-')  // Replace invalid chars with dashes
      .replace(/--+/g, '-')          // Replace multiple dashes with single dash
      .replace(/^-+/, '')            // Remove leading dashes
      .replace(/-+$/, '')            // Remove trailing dashes
    
    // Update the input value
    event.target.value = value
  }
}